import { useNavigate, useParams } from 'react-router-dom';
import './style.css';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { validateOrderId, getStorageOrder } from '../../data/API';
import { ReactSession } from 'react-client-session';
import uuid from 'react-uuid';
import { resetStore } from '../StorageBox/store/actionCreators';
import { resetReduxStore } from '../Packages/store/actionCreators';
import {resetAlaCarteStore } from '../AlaCarteOrder/store/actionCreators';
import { getToken } from '../../utils/token';
import { trackReferralCandyPurchase, clearReferralInfo } from '../../utils/referralCandy';

  export default function OrderConfirmation() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const order_Id = useSelector((state) => state.package.orderId);

    const order_Type = useSelector((state) => state.package.orderType);
    const [currentOrderType, setCurrentOrderType] = useState('');
    const [customerData, setCustomerData] = useState({
      email: '',
      firstName: '',
      lastName: ''
    });
    const [popsicleData, setPopsicleData] = useState(null);
    let { orderId, orderType } = useParams();
    orderId = order_Id ?? orderId;
    orderType = order_Type ?? orderType;

    // useEffect(() => {
    //   const loginToken = getToken();
    //   if (!loginToken) {
    //     navigate('/login', { state: { from: 'orderConfirmation' } });
    //   }
    // }, [navigate]);

    useEffect(() => {
      const urlOrderType = orderType;
      const sessionOrderType = sessionStorage.getItem('orderType');
      setCurrentOrderType(urlOrderType || sessionOrderType || '');
    }, [orderType]);

    // Load customer data and fetch popsicle widget data
    useEffect(() => {
      if (orderId) {
        console.log('Fetching ReferralCandy Popsicle data for order:', orderId);

        fetch(`${process.env.REACT_APP_API_URL}/order/referralcandy-popsicle/${orderId}/`)
          .then(res => res.json())
          .then(data => {
            console.log('Popsicle API response:', data);

            if (data.status === 'skipped') {
              console.log('ReferralCandy popup skipped:', data.message);
              return;
            }

            if (data.status === 'success') {
              setPopsicleData(data.data);

              setCustomerData({
                email: data.data.email,
                firstName: data.data.first_name,
                lastName: data.data.last_name
              });

              setTimeout(() => {
                // Check if div is in DOM
                const lollipopDiv = document.getElementById('refcandy-lollipop');
                console.log('Lollipop div found:', lollipopDiv);
                console.log('Lollipop div attributes:', {
                  id: lollipopDiv?.getAttribute('data-id'),
                  email: lollipopDiv?.getAttribute('data-email'),
                  fname: lollipopDiv?.getAttribute('data-fname')
                });

                if (!document.getElementById('refcandy-lollipop-js')) {
                  const script = document.createElement('script');
                  script.innerHTML = `!function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.defer=true;js.src="//portal.referralcandy.com/assets/widgets/refcandy-lollipop.js";fjs.parentNode.insertBefore(js,fjs);}}(document,"script","refcandy-lollipop-js");`;
                  document.body.appendChild(script);
                  console.log('ReferralCandy Lollipop script loaded successfully');

                  // Check after script loads
                  setTimeout(() => {
                    console.log('Checking for ReferralCandy widgets after 2 seconds...');
                    console.log('refcandy-lollipop-js exists:', !!document.getElementById('refcandy-lollipop-js'));
                    console.log('All scripts:', Array.from(document.scripts).filter(s => s.src.includes('referral')));
                  }, 2000);
                }
              }, 1000); 
            } else {
              console.error('Popsicle API returned error:', data);
            }
          })
          .catch(err => {
            console.error('Error fetching popsicle data:', err);
          });
      } else {
        console.log('Skipping Popsicle: orderId is missing');
      }
    }, [orderId]);

    useEffect(() => {
      if (orderId) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'COMPLETE_REGISTRATION',
          'orderId': orderId,
          'orderType': currentOrderType || 'unknown'
        });


        if (window.fbq) {
          window.fbq('track', 'CompleteRegistration', {
            order_id: orderId,
            order_type: currentOrderType || 'unknown'
          });
        }
        clearReferralInfo();
      }
    }, [orderId, currentOrderType]);
    

    useEffect(() => {
      dispatch(resetReduxStore());
      dispatch(resetAlaCarteStore());
      localStorage.removeItem('package');
      localStorage.removeItem('driverTip');
      localStorage.removeItem('total');
      localStorage.removeItem('movingSupplies');
      localStorage.removeItem('tax');
      localStorage.removeItem('isCartEmpty');
      localStorage.removeItem('packagingSupplies');
      localStorage.removeItem('alaCarte')
  
      if (orderType === 'packages') {
        sessionStorage.removeItem('orderType');
      } else if (orderType === 'storage') {
        sessionStorage.removeItem('orderType');
      }
    }, [orderType]);

    const getorderFunc = async (id) => {
      try {
        if (orderType === 'packages') {
          ReactSession.set('session', uuid());
          return;
        }
        
        let orderStatus = await validateOrderId(id);

        if (!orderStatus?.data?.valid) {
          orderStatus = await getStorageOrder(id);
          if (orderStatus == null) {
            navigate('/404');
            return;
          }
        } else {
          ReactSession.set('session', uuid());
        }
        
        dispatch({ type: 'RESET_REDUX_STORE' });
        dispatch(resetStore());
        localStorage.removeItem('storageState');
      } catch (error) {
        console.log(error);
      }
    };

    useEffect(() => {
      if (orderId && orderType) {
        getorderFunc(orderId);
      }
    }, [orderId, orderType]);

    // const loginToken = getToken();
    // if (!loginToken) {
    //   return null;
    // }

    if (!orderId) {
      return null;
    }


    return (
      <div>
        {/* ReferralCandy Post-Purchase Popup */}
        {popsicleData && (
          <div
            id="refcandy-lollipop"
            data-id={popsicleData.campaign_id || popsicleData.app_id}
            data-id-type="campaign"
            data-fname={popsicleData.first_name}
            data-lname={popsicleData.last_name}
            data-email={popsicleData.email}
            data-accepts-marketing="true"
          />
        )}

        <section className="order-confirmation-section" style={{ marginTop: 0, paddingTop: 0 }}>
          <img
            src="img/order-confirmation.svg"
            className="img-fluid confirm-img-desktop"
            style={{ width: '100%', display: 'block', marginTop: 0 }}
          />
          <img
            src="img/order-confirmation-tab.svg"
            className="img-fluid confirm-img-tab"
            style={{ width: '100%', display: 'block', marginTop: 0 }}
          />
          <img
            src="img/order-confirmation-mobile.svg"
            className="img-fluid confirm-img-mobile"
            style={{ width: '100%', display: 'block', marginTop: 0 }}
          />

          <p className="confirmation-title">
            Thank you for
            <br /> your order!
          </p>
        </section>

        <div className="confirmation-content">
          <div className="content-box">
            {orderType === 'packages' ? (
            <>
              <p className="order-id color-secondary fw-700 mt-3 mb-3">Order Confirmed!</p>
              <p className="order-id color-secondary fw-700">{orderId}</p>
            </>
          ) : (
            <>
              <p>Your Order Id:</p>
              <p className="order-id color-secondary fw-700">{orderId}</p>
            </>
          )}

            {/* Conditional rendering based on order type */}
            {orderType === 'storage-box' ? (
              <>
                <p className="page-titles">
                  You can now visit your My Account page to view your order and subscription details. Your Inventory page is also located there. Once your storage boxes have been delivered, this is where you can update/edit the content of your box(es) and request box deliveries once items are stored with us.
                </p>
                <p className="page-titles">
                  You will also receive an email from info@bluebox.rent and a text message from 858-252-0084 confirming the details of your order. Between 3 pm and 6 pm the day before your scheduled delivery date, you will receive a text message confirming your delivery time frame.
                </p>
              </>
            ) : orderType === 'packages' ? (
              <>
                <p className="page-titles">
                  You should receive an order confirmation email and a text message with all the details of your order. 
                </p>
                <p className="page-titles">
                 Your order details can also be found in our customer portal (click the My Account button above).
                </p>
                <ul className="page-titles">
                  <li><strong>The day before your delivery and pickup:</strong> Between 3 PM and 6 PM we&apos;ll send you a text message confirming your delivery and pick up time frames. (This will be one of the two time frames you chose when placing your order for both delivery and pickup dates.)</li>
                  <li><strong>The day of your delivery and pickup:</strong> You&apos;ll receive an ETA and a live tracking link where you can view your BlueBox driver in real time.</li>
                </ul>
                <p className="page-titles">
                  If you need to change anything regarding this order, please visit our customer portal or contact us by phone or email.
                </p>
              </>
            ) : null}

            <div className="row d-flex" style={{ alignItems: 'center' }}>
              <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 mb-3 support-icon align-content-center">
                <img src="img/icon-phone.svg" className="img-fluid" />
              </div>
              <div className="col-lg-4 col-md-4 col-sm-8 col-xs-8 mb-3 support-title">
                <a
                  className="p-0 support-link"
                  style={{ fontWeight: '400' }}
                  href="tel:650-502-9522">
                  650-502-9522
                </a>
              </div>
              <div className="col-lg-2 col-md-2 col-sm-4 col-xs-4 mb-3 support-icon align-content-center">
                <img src="img/icon-email.svg" className="img-fluid" />
              </div>
              <div className="col-lg-4 col-md-4 col-sm-8 col-xs-8 mb-3 support-title">
                <a
                  className="p-0 support-link"
                  style={{ fontWeight: '400' }}
                  href="mailto:info@bluebox.rent">
                  info@bluebox.rent
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  